import { defineStore } from "pinia";
import { notification } from "ant-design-vue";
import { getAchievement, patchAchievement } from "@/api/learning";
import { ACHIEVEMENT } from "@/interface/learning";
import { ACHIEVEMENT_INFO } from "@/constants/achievement";
import { useUserInfoStore } from "@/store/userInfo";

interface achievementState {
  achievements: Record<ACHIEVEMENT, boolean> | null;
}

export const useAchievementStore = defineStore("achievement", {
  state: (): achievementState => {
    return {
      achievements: null,
    };
  },
  actions: {
    done(achievement: ACHIEVEMENT) {
      const userInfoStore = useUserInfoStore();

      if (this.achievements === null) {
        throw Error("Achievement not loaded!");
      }
      if (!this.achievements[achievement]) {
        patchAchievement(userInfoStore.userId, achievement).then(() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.achievements[achievement] = true;
          notification.success({
            message: "Achievement unlocked!",
            description: ACHIEVEMENT_INFO[achievement].label,
            duration: 0,
          });
        });
      }
    },
    getUserAchievements() {
      getAchievement().then((res) => {
        this.achievements = res.data[0];
      });
    },
  },
});
